/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_File_NameInputs */

const es_settings_files_filters_file_name = /** @type {(inputs: Settings_Files_Filters_File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del archivo`)
};

const en_settings_files_filters_file_name = /** @type {(inputs: Settings_Files_Filters_File_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File name`)
};

/**
* | output |
* | --- |
* | "File name" |
*
* @param {Settings_Files_Filters_File_NameInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_file_name = /** @type {((inputs?: Settings_Files_Filters_File_NameInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_File_NameInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_file_name(inputs)
	return en_settings_files_filters_file_name(inputs)
});
export { settings_files_filters_file_name as "settings.files.filters.file_name" }